// Etiquetas y colores compartidos por la lista y el detalle de solicitudes.
export const TICKET_STATUS = {
  RECEIVED: { label: 'Recibida', bg: '#e0e7ff', color: '#3730a3' },
  IN_PROGRESS: { label: 'En proceso', bg: '#dbeafe', color: '#1d4ed8' },
  WAITING: { label: 'En espera', bg: '#fef3c7', color: '#b45309' },
  RESOLVED: { label: 'Resuelta', bg: '#dcfce7', color: '#15803d' },
}

const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
export function formatDate(iso) {
  const d = new Date(iso)
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`
}
export function formatDateTime(iso) {
  const d = new Date(iso)
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${formatDate(iso)} · ${hh}:${mm}`
}

export const ERROR_MESSAGES = {
  INVALID_CATEGORY: 'Selecciona el tipo de problema.',
  DESCRIPTION_REQUIRED: 'Describe el problema con un poco más de detalle.',
  DESCRIPTION_TOO_LONG: 'La descripción es demasiado larga.',
  INVALID_IMAGE_TYPE: 'La foto debe ser JPG, PNG, WebP o HEIC.',
  IMAGE_TOO_LARGE: 'La foto pesa más de 8 MB. Intenta con otra.',
  TOO_MANY_OPEN_REQUESTS: 'Tienes demasiadas solicitudes abiertas. Espera a que se resuelvan algunas.',
  CONTRACT_NOT_ACTIVE: 'Solo puedes reportar problemas de un contrato vigente.',
  SECTION_DISABLED: 'Esta sección no está disponible.',
  EMPTY_MESSAGE: 'Escribe un mensaje o adjunta una foto.',
  MESSAGE_TOO_LONG: 'El mensaje es demasiado largo.',
}